import { insertScript, waitFor, isAsync } from '../util/utils';
import { writeOembedResult } from '../util/oembed';
import _waitForIframe from '../util/wait-for-iframe';

const noop = (sdk?) => {};


export default function BaseProvider({ id, url, globalName, prevInit = noop, postInit = noop }) {
  let initialized = false;

  provider.provideSDK = provideSDK;
  provider.createCacheElement = createCacheElement;
  provider.showContent = showContent;

  return provider;

  async function provider(): Promise<{ [key: string]: any }> {
    return await waitFor(() => window[globalName]);
  }

  async function provideSDK(): Promise<{ [key: string]: any }> {
    if (initialized) {
      return;
    }

    initialized = true;

    if (isAsync(prevInit)) {
      await prevInit();
    } else {
      prevInit();
    }

    await insertScript(url, id);
    const sdk = await provider();

    if (isAsync(postInit)) {
      await postInit();
    } else {
      postInit(sdk);
    }
  }
}

async function createCacheElement(
  container,
  oembedResponse,
  {
    dataAttributes = {} as { [key: string]: any },
    waitForIframe = true
  } = {}
 ) {
  const cacheElement = writeOembedResult({ element: container, oembedResponse, dataAttributes });
  if (!cacheElement) return;

  if (waitForIframe) {
    _waitForIframe(cacheElement, () => {
      const contentElement = container.querySelector('[data-content]');
      contentElement.innerHTML = '';
      contentElement.appendChild(cacheElement.firstElementChild);
    });
  }

  return cacheElement;
}

function showContent(cacheContainer) {
  const contentElement = cacheContainer.nextElementSibling;
  contentElement.innerHTML = '';
  contentElement.appendChild(cacheContainer.firstChild);
}
